'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef } from 'react';
import { styled } from 'styled-components';
import { space } from '../../abstracts';
import { dontForwardProps } from '../../util';
export const Container = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1mvllbe-0"
})(["align-items:", ";box-sizing:border-box;display:flex;flex-direction:column;gap:", ";width:100%;"], props => props.alignItems || 'flex-start', props => props.gap ?? space[300]);
export const AuiContainer = /*#__PURE__*/forwardRef((props, fRef) => /*#__PURE__*/React.createElement(Container, _extends({
  "data-aui": "container",
  ref: fRef
}, props)));